export const COMMUNICATIONS_SERVICE_ROWS = [
    {
        qtyField: "communications_orbit_qty",
        packageName: "Orbit",
        description: "Single Satellite Connection, 99% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service",
    },
    {
        qtyField: "communications_galaxy_qty",
        packageName: "Galaxy",
        description: "Dual Satellite Bonded Connection, 99.5% site uptime, 20Mb - 30Mb Upload Speed, Installation and Configuration Service (Automatic Failover)",
    },
    {
        qtyField: "communications_cosmos_qty",
        packageName: "Cosmos",
        description: "Triple Satellite Bonded Connection, 99.5% site uptime, 30Mb - 50Mb Upload Speed, Installation and Configuration Service (Automatic Failover)",
    },
    {
        qtyField: "communications_skylink_qty",
        packageName: "Skylink",
        description: "Single Satellite Connection, + LTE Bonded 99.9% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service (Automatic Failover)",
    },
    {
        qtyField: "communications_lte_swift_qty",
        packageName: "LTE Swift",
        description: "LTE 4G/5G LTE 99% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service",
    },
    {
        qtyField: "communications_lte_velocity_qty",
        packageName: "LTE Velocity",
        description: "LTE 4G/5G LTE MultiSim Bonded 99% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service",
    },
    {
        qtyField: "communications_lte_pulse_qty",
        packageName: "LTE Pulse",
        description: "LTE 4G/5G LTE Advanced Single Contained Advanced Unit 99% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service",
    },
    {
        qtyField: "communications_lte_flight_qty",
        packageName: "LTE Flight",
        description: "LTE 4G/5G LTE Mini Unit 99% uptime, 10Mb - 20Mb Upload Speed, Installation and Configuration Service",
    },
    {
        qtyField: "communications_fibre_edge_qty",
        packageName: "FibreEdge",
        description: "If multiple circuits are selected does this need to be fully diverse routing?",
    },
    {
        qtyField: "communications_fibre_access_qty",
        packageName: "FibreAccess",
        description: "If multiple circuits are selected does this need to be diverse carriers?",
    },
];
export const COMMUNICATIONS_SERVICE_QTY_DEFAULTS = COMMUNICATIONS_SERVICE_ROWS.reduce((acc, row) => {
    acc[row.qtyField] = 0;
    return acc;
}, {});
export const hasCommunicationsServiceSelection = (form) => COMMUNICATIONS_SERVICE_ROWS.some((row) => (Number(form[row.qtyField]) || 0) > 0);
export const getActiveCommunicationsServices = (form) => COMMUNICATIONS_SERVICE_ROWS.filter((row) => (Number(form[row.qtyField]) || 0) > 0);
export const getCommunicationsServiceRow = (qtyField) => COMMUNICATIONS_SERVICE_ROWS.find((row) => row.qtyField === qtyField);
